module.exports = __webpack_public_path__ + "static/media/app-platform-login-promo-bg-v2.82c1cd08.jpg";